import { IOrganization } from './../../../../interfaces/graph-types';
import {
  Component,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { AccountService } from '../../../../services/account.service';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalConfirmSubscriptionComponent } from '../../../modals/confirm-subscription/modal-confirm-subscription.component';
import { UtilityService } from '../../../../services/utility.service';
import { Subscription } from 'rxjs';
import { SubscriptionService } from '../../../../services/subscription.service';
import {
  ISubscription,
  IAccount,
  IBilling,
} from '../../../../interfaces/graph-types';
import { ModalUpdateCardComponent } from '../../../modals/update-card/modal-update-card.component';
import { ModalConfirmUnsubscribeComponent } from '../../../modals/confirm-unsubscribe/modal-confirm-unsubscribe.component';
import { GlobalWindow } from '../../../../main.window';
import { DynamicScriptLoaderService } from '../../../../services/dynamic-script-loader.service';
import { ModalModifySubscriptionComponent } from '../../../modals/modify-subscription/modify-subscription.component';

declare let window: GlobalWindow;

//declare var stripe: any;

//declare var Stripe: stripe.StripeStatic;

// -------------------------------------------------------------------
export class ICreateAccountSubscriptionInfo {
  inboxes: number;
  inboxesMin: number;
  billing: string;
  plan: string;
}

// -------------------------------------------------------------------
@Component({
  selector: '[account-subscription]',
  template: require('./account-subscription.component.pug'),
  styles: [require('./account-subscription.component.css').toString()],
})
export class AccountSubscriptionComponent {
  input: ICreateAccountSubscriptionInfo;
  bsModalRef: BsModalRef;
  sub: Subscription = null;
  subReason: Subscription = null;
  subBilling: Subscription = null;
  subscription: ISubscription;

  account: IAccount = null;

  @ViewChild('cardElement') cardElement: ElementRef;
  cardNumber: string;
  cardName = '';

  card;
  error = null;
  confirmation;

  elements: any;

  // -------------------------------------------------------------------
  constructor(
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
    private cd: ChangeDetectorRef,
    private modalService: BsModalService,
    private subscriptionService: SubscriptionService,
    private utilityService: UtilityService,
    private dynamicScriptLoader: DynamicScriptLoaderService,
  ) {
    this.input = new ICreateAccountSubscriptionInfo();
    this.input.billing = 'monthly';
    this.input.plan = null;
  }

  stripe;

  // -------------------------------------------------------------------
  ngOnInit(): void {
    this.dynamicScriptLoader
      .load('stripe')
      .then(data => {
        this.stripe = Stripe(window.stripe_pub_key);

        this.checkSubscription();
        this.checkBilling();

        console.log('Stripe initialized');
      })
      .catch(error => {
        console.error(error);
      });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.subBilling) {
      this.subBilling.unsubscribe();
    }
    if (this.subReason) {
      this.subReason.unsubscribe();
    }
  }

  loading: boolean = false;

  // -------------------------------------------------------------------
  checkSubscription() {
    this.loading = true;
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.subscriptionService
      .subscription(this.watchAccount.accountId().getValue())
      .subscribe(response => {
        this.loading = false;

        this.account = response;
        this.subscription = response.subscription;
        this.watchAccount.subscription.next(this.subscription);
      });
  }

  loadingBilling: boolean = false;
  billing: IBilling = null;
  org: IOrganization = null;
  discount: number = null;

  // -------------------------------------------------------------------
  checkBilling() {
    this.loadingBilling = true;
    if (this.subBilling) {
      this.subBilling.unsubscribe();
    }
    this.subBilling = this.accountService
      .billing(this.watchAccount.accountId().getValue())
      .subscribe(response => {
        this.org = response.organization;
        this.billing = response.organization.billing;
        this.discount = response.organization.billing.discountPercent;
        this.loadingBilling = false;
      });
  }

  // -------------------------------------------------------------------
  onSelect(plan) {
    this.input.plan = plan;

    //this.account_service.account().subscribe(response => {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      plan: plan,
      inboxes: this.input.inboxes,
      discount: this.discount,
      stripe: this.stripe,
    };
    this.bsModalRef = this.modalService.show(
      ModalConfirmSubscriptionComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';

    this.subReason = this.bsModalRef.content.reason.subscribe(res => {
      if (res) {
        this.watchAccount.isTrial.next(false);
        this.watchAccount.isExpired.next(false);
        this.watchAccount.pendingPayment.next(false);
        this.watchAccount.pastDue.next(false);
        this.checkSubscription();
      }
    });
  }

  // -------------------------------------------------------------------
  setBilling(billing: string) {
    this.input.billing = billing;
  }

  // -------------------------------------------------------------------
  private addInbox() {
    this.input.inboxes = this.input.inboxes + 1;
  }

  // -------------------------------------------------------------------
  private canRemoveInbox() {
    return this.input.inboxes <= this.input.inboxesMin;
  }

  // -------------------------------------------------------------------
  private removeInbox() {
    this.input.inboxes = this.input.inboxes - 1;
    if (this.input.inboxes < 1) {
      this.input.inboxes = 1;
    }
  }

  // -------------------------------------------------------------------
  private getPrice(plan) {
    const price = this.utilityService.getPricing(
      plan,
      this.input.inboxes,
      this.input.billing,
    );

    return this.utilityService.formatPrice(price, this.input.billing);
  }

  // -------------------------------------------------------------------
  private getPriceWithDiscount(plan) {
    const price = this.utilityService.getPricing(
      plan,
      this.input.inboxes,
      this.input.billing,
    );

    const withDiscount = this.utilityService.getPricingWithDiscount(
      price,
      this.discount,
    );

    return this.utilityService.formatPrice(withDiscount, this.input.billing);
  }

  // -------------------------------------------------------------------
  private getPricePerInbox(plan) {
    const price = this.utilityService.getInboxPricing(plan);

    return this.utilityService.formatPrice(price, 'month');
  }

  // -------------------------------------------------------------------
  private getPricePerInboxWithDiscount(plan) {
    const price = this.utilityService.getInboxPricing(plan);

    const withDiscount = this.utilityService.getPricingWithDiscount(
      price,
      this.discount,
    );

    return this.utilityService.formatPrice(withDiscount, 'month');
  }

  // -------------------------------------------------------------------
  changeCard() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      //plan: plan,
      //inboxes: this.input.inboxes,
    };
    this.bsModalRef = this.modalService.show(ModalUpdateCardComponent, options);
    this.bsModalRef.content.closeBtnName = 'Close';

    this.subReason = this.bsModalRef.content.reason.subscribe(res => {
      if (res) {
        // card updated?
        this.checkBilling();
      }
    });
  }

  // -------------------------------------------------------------------
  onModify() {
    //this.account_service.account().subscribe(response => {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      accountId: this.watchAccount.accountId().getValue(),
      plan: this.subscription.name,
      minInbox: this.input.inboxesMin,
      quantity: this.subscription.quantity,
      cycle: this.subscription.cycle,
      subscription: this.subscription,
      discount: this.discount,
    };
    this.bsModalRef = this.modalService.show(
      ModalModifySubscriptionComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';

    this.subReason = this.bsModalRef.content.reason.subscribe(res => {
      // Reload info
      this.checkSubscription();
    });
  }

  // -------------------------------------------------------------------
  onCancel() {
    //this.account_service.account().subscribe(response => {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      //plan: plan,
      //inboxes: this.input.inboxes,
      accountId: this.watchAccount.accountId().getValue(),
    };
    this.bsModalRef = this.modalService.show(
      ModalConfirmUnsubscribeComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';

    this.subReason = this.bsModalRef.content.reason.subscribe(res => {
      if (res) {
        this.subscription = null;
        this.watchAccount.subscription.next(null);
        this.watchAccount.isTrial.next(false);
        this.watchAccount.pendingPayment.next(false);
        this.watchAccount.pastDue.next(false);
        this.watchAccount.isExpired.next(true);
      }
    });
  }

  // -------------------------------------------------------------------
  confirmPayment() {
    this.loading = true;
    this.error = null;

    this.accountService.initiatePaymentIntent(
      this.watchAccount.accountId().getValue(),
      res => {
        this.stripe
          .handleCardPayment(
            res.clientSecret, // "pi_1FNqHdAkNDVprSsPY1bMN6Pn_secret_5v5Se9YHIfVPzFLn90Mc5EYYS"
            {
              payment_method: res.paymentMethod, // 'pm_1FK3FtAkNDVprSsPzSemkTNq',
              setup_future_usage: 'off_session',
            },
          )
          .then(result => {
            if (result.error) {
              // Display error.message in your UI.
              //debugger;
              this.error = result.error.message;
              //this.cd.detectChanges();
              this.loading = false;
            } else {
              // The SetupIntent was successful! ask server to refresh the subscription status (don't wait for webhooks)
              //debugger;
              // The SetupIntent was successful!, ask the server to refresh the subscription status
              this.accountService.refreshSubscription(
                this.watchAccount.accountId().getValue(),
                res => {
                  // All good
                  this.checkSubscription();
                  return;
                },
                error => {
                  console.error(error);
                  this.error = error;
                  return;
                },
              );

              //let paymentMethod = result.setupIntent.payment_method;
              /*this.organizationService.completePaymentIntent(
              this.org_id,
              paymentMethod,
              res => {
                window.location.href = '/org/' + this.org_id;
              },
              error => {
                console.warn('ERROR:');
                console.warn({ error });
                this.error = error;
                this.loading = false;
                //this.cd.detectChanges();
              },
            );*/
            }
          });
      },
      error => {
        console.warn('STRIPE ERROR:');
        console.warn({ error });
        this.error = error;
        this.loading = false;
      },
    );
  }
}
